import {ref} from "vue";

export default new class PrelaunchManager {

	public reactiveIsActive = ref<boolean>(import.meta.env.VITE_PRELAUNCH_ACTIVE === 'true');

}
